// extracted by mini-css-extract-plugin
var _1 = "CollaboratorSearchStyles-module__collaborators-search___EiHyz";
var _2 = "CollaboratorSearchStyles-module__collaborators-search___EiHyz";
var _3 = "CollaboratorSearchStyles-module__invite-btn___XFCMl";
var _4 = "CollaboratorSearchStyles-module__invite-btn___XFCMl";
var _5 = "CollaboratorSearchStyles-module__option-holder___caBnT";
var _6 = "CollaboratorSearchStyles-module__option-holder_img___mkHXf";
var _7 = "CollaboratorSearchStyles-module__option-holder___caBnT";
var _8 = "CollaboratorSearchStyles-module__option-holder_img___mkHXf";
var _9 = "CollaboratorSearchStyles-module__select-holder___dnveG";
var _a = "CollaboratorSearchStyles-module__select-holder_p___Z_pZo";
var _b = "CollaboratorSearchStyles-module__select-holder___dnveG";
var _c = "CollaboratorSearchStyles-module__select-holder_p___Z_pZo";
export { _1 as "collaborators-search", _2 as "collaboratorsSearch", _3 as "invite-btn", _4 as "inviteBtn", _5 as "option-holder", _6 as "option-holder_img", _7 as "optionHolder", _8 as "optionHolderImg", _9 as "select-holder", _a as "select-holder_p", _b as "selectHolder", _c as "selectHolderP" }
